import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions, TopicStatus } from './index';
import { TopicCreateBody } from './create';

export type TopicUpdateResponse = { success: boolean };

export interface TopicUpdateBody extends Partial<TopicCreateBody> {
  status?: TopicStatus;
}

export interface TopicUpdatePayload {
  id: string;
  body: TopicUpdateBody
}

export const topicUpdate = (payload: TopicUpdatePayload): Action<TopicUpdatePayload> => ({
  type: actions.topicUpdateTrigger.toString(),
  payload,
});

export const topicUpdateClear = (): Action => ({
  type: actions.topicUpdateClear.toString(),
});

export const topicUpdateErrorClear = (): Action => ({
  type: actions.topicUpdateErrorReset.toString(),
});

export function* topicUpdateRequestSaga({ payload }: Action<TopicUpdatePayload>) {
  yield put({
    type: actions.topicUpdateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.topicUpdateError.toString(),
      payload: {
        message: 'TopicUpdate: Parameters not passed.',
      },
    });

    return;
  }

  const { id, body } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/topics/${id}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<TopicUpdateResponse, TopicUpdateResponse>(
    response,
    actions.topicUpdateSuccess.toString(),
    actions.topicUpdateError.toString(),
    false,
    (topicUpdateData) => topicUpdateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.topicUpdateTrigger.toString(),
    defaultProcessingSaga(
      topicUpdateRequestSaga,
      {
        error: actions.topicUpdateError.toString(),
        locationCancel: actions.topicUpdateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.topicUpdateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.topicUpdateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.topicUpdateErrorReset.toString(),
    });
  });
}
